import { useTheme } from "@mui/material/styles";
import { useCallback } from "react";
import { getThemeColor } from "../theme/util.js";
const useThemeColor = () => {
  const theme = useTheme();
  return useCallback(
    (color) => {
      return getThemeColor(theme, color);
    },
    [theme]
  );
};
export {
  useThemeColor
};
//# sourceMappingURL=useThemeColor.js.map
